/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';
import { generateAnalyticsInteractionEvent } from '../utils/generateAnalyticsInteractionEvent';

export default (set, get) => {
  set(
    produce(get(), (draft) => {
      if (!draft.digitalData) {
        draft.digitalData = { event: [] };
      }
      const component = 'fly out';
      const section = 'your cabinet project';
      const target = 'about this collection';
      const event = generateAnalyticsInteractionEvent(section, target, component);

      const eventClone = _cloneDeep(event);
      draft.digitalData.event.push(event);
      Analytics.sendAnalyticsEvent(eventClone);
    }),
    false,
    { type: 'ABOUT_THIS_COLLECTION_EVENT' }
  );
};